module.exports = __webpack_public_path__ + "static/guinness-671df4c743f715ce93973c4170543c84.svg";